import { render, staticRenderFns } from "./PageLoading.vue?vue&type=template&id=a8bfb2c8&scoped=true&"
import script from "./PageLoading.vue?vue&type=script&lang=js&"
export * from "./PageLoading.vue?vue&type=script&lang=js&"
import style0 from "./PageLoading.vue?vue&type=style&index=0&id=a8bfb2c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bfb2c8",
  null
  
)

export default component.exports